import { motion } from 'framer-motion'

/**
 * Skeleton loading blocks — pulse animation, glass-tile look. Prefer these
 * over "Loading…" text in every screen that fetches. They give the eye
 * something to lock onto during the network round-trip.
 */

export function SkeletonBlock({ h = 20, w = '100%', rounded = 8 }: { h?: number | string; w?: number | string; rounded?: number }) {
  return (
    <motion.div
      className="bg-text-primary/8"
      style={{ height: h, width: w, borderRadius: rounded }}
      animate={{ opacity: [0.4, 0.8, 0.4] }}
      transition={{ duration: 1.4, repeat: Infinity, ease: 'easeInOut' }}
    />
  )
}

export function SkeletonCard({ lines = 3 }: { lines?: number }) {
  return (
    <div className="glass-tile p-4 space-y-3">
      <SkeletonBlock h={14} w="40%" />
      {Array.from({ length: lines }).map((_, i) => (
        <SkeletonBlock key={i} h={12} w={`${60 + ((i * 17) % 30)}%`} />
      ))}
    </div>
  )
}

export function SkeletonList({ rows = 4 }: { rows?: number }) {
  return (
    <div className="space-y-3">
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="glass-tile p-4 flex items-center gap-3">
          <SkeletonBlock h={40} w={40} rounded={9999} />
          <div className="flex-1 space-y-2">
            <SkeletonBlock h={14} w="60%" />
            <SkeletonBlock h={11} w="35%" />
          </div>
        </div>
      ))}
    </div>
  )
}

export function SkeletonHero() {
  return (
    <div className="glass-tile p-6 space-y-4">
      <SkeletonBlock h={10} w={100} />
      <SkeletonBlock h={64} w="70%" rounded={12} />
      <SkeletonBlock h={16} w="45%" />
      <SkeletonBlock h={12} w="30%" />
    </div>
  )
}
